import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { compose } from 'redux';
import { useNavigate } from 'react-router-dom';
import {
  CTA,
  CustomInput,
  CustomSelect,
  NoResult,
  Text,
} from '../../../ui/atoms';
import {
  Filter,
  SelectsContainer,
  FiltersContainer,
  Legend,
  ResultsSorting,
  CourseCard,
} from './style';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { StickyFiltersWrapper } from '../../../ui/atoms/CTA/style';
import { MODAL_OPEN } from '../../redux/actions';
import { VISIBILITY_OPTIONS } from '../../../utils/labels';
import ModalFilters, {
  ModalFiltersId,
} from '../../../ui/atoms/Modals/ModalFilters';
import SortBy from '../../../ui/atoms/SortBy';
import { flattenCategories } from '../../../utils/categories';
import {
  TUTOR_COURSE_DELETE,
  TUTOR_COURSE_LIST_GET,
} from '../../redux/actions/tutorCourseList';
import Pagination from '../../../ui/atoms/Pagination';
import routes from '../../../routes';
import ModalConfirm, {
  ModalConfirmId,
} from '../../../ui/atoms/Modals/ModalConfirm';
import { timestampToDate } from '../../../utils/common';
import MultiActions from '../../../ui/atoms/MultiActions';

const CourseList = ({
  mediaIsPhone,
  mediaIsTablet,
  active,
  categories,
  filters,
  list,
  pager,
  getCourseList,
  modalOpen,
  deleteCourse,
}) => {
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState();
  const [subjects, setSubjects] = useState([]);
  // filters
  const [selectedFilters, setSelectedFilters] = useState({});
  const [searchValue, setSearchValue] = useState();

  useEffect(() => {
    return () => {
      setSelectedFilters({});
      setSubjects([]);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedFilters?.category) {
      const currentCategory = categories?.find(
        (c) => c?.id === selectedFilters?.category
      );
      const newSubjects = flattenCategories(currentCategory?.children, 0, true);
      setSubjects(newSubjects);
    } else setSubjects([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters?.category]);

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) handleGetCourses();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value || value;
    setSelectedFilters(newFilters);
  };

  const handleGetCourses = (page) => {
    const parsedFilters = {
      ...selectedFilters,
      parent_categories: selectedFilters?.category,
      single_categories: selectedFilters?.subject,
      page,
    };
    if (parsedFilters?.subject) {
      delete parsedFilters?.parent_categories;
    }
    delete parsedFilters.category;
    delete parsedFilters.subject;
    getCourseList(parsedFilters);
  };

  const onClickSearch = () => {
    setSelectedFilters({ ...selectedFilters, search_text: searchValue });
  };

  const loadMore = (page) => handleGetCourses(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  const getActions = (item) => {
    if (item?.owner) {
      return [
        {
          label: 'Modifica',
          icon: 'edit-05',
          onClick: () => navigate(`${routes.editCourse.path}/${item.id}`),
        },
        {
          label: 'Elimina',
          icon: 'trash-01',
          onClick: () => {
            setSelectedItem(item);
            modalOpen(ModalConfirmId);
          },
        },
      ];
    }
    return [
      {
        label: 'Modifica',
        icon: 'edit-05',
        onClick: () => navigate(`${routes.editCourse.path}/${item.id}`),
      },
    ];
  };

  return (
    <>
      <div>
        {mediaIsPhone ? (
          <>
            <StickyFiltersWrapper mb={16} stickyPosition={0}>
              <CustomInput
                placeholder="Cosa vuoi cercare?..."
                isSearch
                value={searchValue}
                icon="search-sm"
                isClearable
                onChange={(v) => setSearchValue(v)}
                onClickIcon={onClickSearch}
                onKeyPress={(event) => {
                  if (event.key === 'Enter') onClickSearch();
                }}
              />
              <CTA
                classes="small-btn"
                btnText="Filtri"
                type="secondary"
                onClick={() =>
                  modalOpen(ModalFiltersId, {
                    filters: {
                      category: categories,
                      subject: subjects,
                      ...filters,
                      course_status: VISIBILITY_OPTIONS,
                    },
                    activeFilters: selectedFilters,
                  })
                }
              />
            </StickyFiltersWrapper>
            <Text type="b3" mb={24}>
              {pager?.total_items || 0} percorsi formativi disponibili
            </Text>
          </>
        ) : (
          <>
            <FiltersContainer>
              <SelectsContainer>
                <Filter>
                  <CustomInput
                    placeholder="Cosa vuoi cercare?..."
                    isSearch
                    value=""
                    icon="search-sm"
                    isClearable
                    onChange={(v) => setSearchValue(v)}
                    onClickIcon={onClickSearch}
                    onKeyPress={(event) => {
                      if (event.key === 'Enter') onClickSearch();
                    }}
                  />
                </Filter>
                <Filter>
                  <CustomSelect
                    size="s"
                    placeholder="Area tematica"
                    options={categories}
                    isClearable
                    onChange={(v) =>
                      setSelectedFilters({
                        ...selectedFilters,
                        category: v?.id,
                      })
                    }
                    selected={
                      categories?.find(
                        (c) => c.id === selectedFilters?.category
                      ) ?? null
                    }
                  />
                </Filter>
                {subjects?.length > 0 && (
                  <Filter>
                    <CustomSelect
                      size="s"
                      placeholder="Materia"
                      options={subjects}
                      isClearable
                      onChange={(v) =>
                        setSelectedFilters({
                          ...selectedFilters,
                          subject: v?.value,
                        })
                      }
                      selected={
                        subjects?.find(
                          (s) => s.value === selectedFilters?.subject
                        ) ?? null
                      }
                    />
                  </Filter>
                )}
                <Filter>
                  <CustomSelect
                    size="s"
                    placeholder="Stato"
                    options={VISIBILITY_OPTIONS}
                    isClearable
                    onChange={(v) =>
                      setSelectedFilters({
                        ...selectedFilters,
                        course_status: v?.value,
                      })
                    }
                  />
                </Filter>
              </SelectsContainer>
            </FiltersContainer>
            <ResultsSorting>
              <Text type="b3">
                {pager?.total_items || 0} percorsi formativi disponibili
              </Text>
              <SortBy
                onChange={(v) => {
                  setSelectedFilters({
                    ...selectedFilters,
                    sort_by: v?.value,
                  });
                }}
              />
            </ResultsSorting>
          </>
        )}
        {list?.length > 0 ? (
          <>
            {!(mediaIsPhone || mediaIsTablet) && (
              <Legend>
                <Text type="h3.5">CODICE</Text>
                <Text type="h3.5">TITOLO PERCORSO FORMATIVO</Text>
                <Text type="h3.5">AREA TEMATICA</Text>
                <Text type="h3.5">MATERIA</Text>
                <Text type="h3.5">Stato</Text>
                <Text type="h3.5">Data di creazione</Text>
              </Legend>
            )}
            {list.map((item, i) => {
              if (mediaIsPhone || mediaIsTablet) {
                return (
                  <CourseCard
                    key={`course-${item?.id}`}
                    className={i + 1 === list?.length ? 'last' : ''}
                  >
                    <div />
                    <MultiActions actions={getActions(item)} />
                    <Text type="h5">Codice</Text>
                    <Text type="h3">{item?.code || '-'}</Text>
                    <Text type="h5">TITOLO PERCORSO FORMATIVO </Text>
                    <Text type="h3">{item?.title}</Text>
                    <Text type="h5">AREA TEMATICA </Text>
                    <Text type="b4" className="category">
                      {item?.category}
                    </Text>
                    <Text type="h5">MATERIA </Text>
                    <Text type="b4" className="category">
                      {item?.subject || '-'}
                    </Text>
                    <Text type="h5">Stato </Text>
                    <Text type="b4" className="category">
                      {item?.published ? 'Visibile' : 'Non visibile'}
                    </Text>
                    <Text type="h5">Data di creazione</Text>
                    <Text type="b4">{timestampToDate(item?.created)}</Text>
                  </CourseCard>
                );
              }

              return (
                <CourseCard
                  key={`course-${item?.id}`}
                  className={i + 1 === list?.length ? 'last' : ''}
                >
                  <Text type="b5">{item?.code}</Text>
                  <Text type="h3">{item?.title}</Text>
                  <Text type="b4" className="category">
                    {item?.category}
                  </Text>
                  <Text type="b4" className="category">
                    {item?.subject || '-'}
                  </Text>
                  <Text type="b4" className="category">
                    {item?.published ? 'Visibile' : 'Non visibile'}
                  </Text>
                  <Text type="b4">{timestampToDate(item?.created)}</Text>
                  <MultiActions actions={getActions(item)} />
                </CourseCard>
              );
            })}
          </>
        ) : (
          <NoResult />
        )}
        <Pagination
          pager={pager}
          callBack={loadMore}
          setItemsPerPage={setItemsPerPage}
        />
      </div>
      {active && (
        <>
          {mediaIsPhone && (
            <ModalFilters
              onClick={(newFilters) =>
                setSelectedFilters({
                  ...newFilters,
                  search_text: selectedFilters.search_text,
                })
              }
            />
          )}
          <ModalConfirm
            onClick={() =>
              deleteCourse({
                id: selectedItem.id,
                callback: handleGetCourses,
              })
            }
            title="Attenzione"
          >
            <Text type="b3">
              Cliccando su "Conferma" canecellerai il corso{' '}
              <b>"{selectedItem?.title}"</b>.
            </Text>
            <Text type="b3"> Il processo non è reversibile.</Text>
          </ModalConfirm>
        </>
      )}
    </>
  );
};

CourseList.propTypes = {
  active: PropTypes.bool,
  mediaIsPhone: PropTypes.bool,
  mediaIsTablet: PropTypes.bool,
  // HOC (connect, state)
  categories: PropTypes.array,
  filters: PropTypes.object,
  list: PropTypes.array,
  pager: PropTypes.object,
  // HOC (connect, dispatch)
  modalOpen: PropTypes.func.isRequired,
  getCourseList: PropTypes.func.isRequired,
  deleteCourse: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const { list, pager } = state.tutorCourseList.courseList;
      const { categories } = state.courselist;
      return { categories, list, pager };
    },
    (dispatch) => ({
      modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
      getCourseList: (filters = {}) =>
        dispatch({ type: TUTOR_COURSE_LIST_GET._REQUEST, filters }),
      deleteCourse: ({ id, callback }) =>
        dispatch({ type: TUTOR_COURSE_DELETE._REQUEST, id, callback }),
    })
  ),
  withMediaQueries
)(CourseList);
